import BottomNavDrone from './BottomNavDrone';

export default BottomNavDrone;
